// src/helpers/factories/settings/rolesDropdownFactory.ts
var rolesDropdownFactory = (roles, currentRoles) => {
  const toRemoveRoles = new Set(currentRoles);
  return Object.keys(roles).map((roleId) => ({
    label: roles[roleId].name,
    value: Number(roleId)
  })).filter(({ value }) => !toRemoveRoles.has(value));
};

export { rolesDropdownFactory };
